/**
 * * Note the commented out sections "skins", "customSkins", and "clips".
 * * These are not used in the current implementation but are left here for reference, simply carried over from the json files found at {path}/{json}.
 * * Of course they can be written in any format, since they are just lists to be read by the devs.
 */

export const assetConfigSpineLiteral = {
  bot: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/bot/v9',
    json: 'player_bot.json',
    atlas: 'player_bot.atlas'
    // skins: [
    //   'default'
    // ],
    // customSkins: [
    //   {
    //     name: 'defaultDog',
    //     partSkins: ['dog_body', 'dog_helmet', 'dog_legs', 'dog_tail']
    //   },
    //   {
    //     name: 'defaultWolf',
    //     partSkins: ['wolf_body', 'wolf_helmet', 'wolf_legs', 'wolf_tail']
    //   }
    // ],
    // clips: [
    //   '.backflip',
    //   '.bite',
    //   '.claw_swipe',
    //   '.damage',
    //   '.death',
    //   '.digging',
    //   '.headbutt',
    //   '.howl',
    //   '.howling_down',
    //   '.idle',
    //   '.respawn',
    //   '.shoot',
    //   '.shoot_with_recoil',
    //   '.sit',
    //   'bite.begin',
    //   'bite.end',
    //   'claw_swipe.begin',
    //   'claw_swipe.end',
    //   'digging.begin',
    //   'digging.cycle',
    //   'digging.end',
    //   'headbutt.begin',
    //   'headbutt.end',
    //   'howling_down.begin',
    //   'howling_down.cycle',
    //   'howling_down.end',
    //   'run_galloping',
    //   'run_heavy',
    //   'run_mid',
    //   'shoot.begin',
    //   'shoot.end',
    //   'shoot_with_recoil.begin',
    //   'shoot_with_recoil.end'
    // ]
  },
  bot_unmeshed: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/bot/v9/avatar_service_bot',
    json: 'player_bot_unmeshed.json',
    atlas: 'player_bot.atlas'
    // skins: [],
    // clips: []
  },
  minion_drone: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/drone',
    json: 'drone.json',
    atlas: 'drone.atlas'
    // skins: [
    //   'default'
    // ],
    // clips: [
    //   'idle',
    //   'attack',
    //   'dmg',
    //   'walk'
    // ]
  },
  minion_ant: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/minion/v3/minion_ant',
    json: 'minion_ant.json',
    atlas: 'minion_ant.atlas'
    // skins: [
    //   'default'
    // ],
    // clips: [
    //   'anim_idle',
    //   'anim_attack',
    //   'anim_damage',
    //   'anim_walk',
    //   'anim_idle2'
    // ]
  },
  puffball_follower: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/minion/puffbot',
    json: 'PuffBot.json',
    atlas: 'PuffBot.atlas'
    // skins: [
    //   'default'
    // ],
    // clips: [
    //   '.spawn',
    //   'spawn.create',
    //   'spawn.activate',
    //   'idle',
    //   'run',
    //   '.shoot',
    //   'deactivated'
    // ]
  },
  ram_bot: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/skills/alpha_ram/',
    json: 'RamBot.json',
    atlas: 'RamBot.atlas'
    // skins: [
    //   'default'
    // ],
    // clips: [
    //   '.view.charge',
    //   '.view.run',
    //   'death',
    //   'death.dark',
    //   'headbutt_a',
    //   'headbutt_b',
    //   'hit',
    //   'idle',
    //   'run',
    //   'run.charge',
    //   'spawn'
    // ]
  },
  building_tower_dom: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/minion/v2/dom-tower',
    json: 'full_tower.json',
    atlas: 'full_tower.atlas'
    // skins: [
    //   'default'
    // ],
    // clips: [
    //   'spawn',
    //   'idle',
    //   'attack',
    //   'dead',
    //   'dead_high',
    //   'destroy'
    // ]
  },
  building_tower: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/minion/v2/tr-tower',
    json: 'tower.json',
    atlas: 'tower.atlas'
    // skins: [
    //   'state_01',
    //   'state_02',
    //   'state_broken'
    // ],
    // clips: [
    //   'idle',
    //   'charge',
    //   'shoot',
    //   'destroy'
    // ]
  },
  building_power_generator: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/minion/v2/tr-power-generator',
    json: 'powergenerator.json',
    atlas: 'powergenerator.atlas'
    // skins: [
    //   'state_01',
    //   'state_02',
    //   'state_broken'
    // ],
    // clips: [
    //   'static',
    //   'idle',
    //   'destroy',
    //   'destroyed'
    // ]
  },
  skill_swatter_swing: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/skills/swatterswing',
    json: 'vfx_part_skill_swatterswing.json',
    atlas: 'vfx_part_skill_swatterswing.atlas'
    // skins: [
    //   'default'
    // ],
    // clips: [
    //   '.swatter_swing',
    //   'swatter_swing_arc',
    //   'swatter_swing_spark'
    // ]
  },
  skill_cavalry_charge: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/skills/cavalrycharge',
    json: 'vfx_part_skill_cavalrycharge.json',
    atlas: 'vfx_part_skill_cavalrycharge.atlas'
    // skins: [
    //   'default'
    // ],
    // clips: [
    //   '.cavalry_charge',
    //   'cavalry_charge.begin',
    //   'cavalry_charge.end'
    // ]
  },
  skill_mane_event: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/skills/maneevent',
    json: 'vfx_part_skill_maneevent.json',
    atlas: 'vfx_part_skill_maneevent.atlas'
    // skins: [
    //   'default'
    // ],
    // clips: [
    //   '.mane_event',
    //   '.mane_event_fireHead',
    //   'mane_event_fireHead.begin',
    //   'mane_event_fireHead.cycle',
    //   'mane_event_fireHead.end',
    //   'mane_event_energySphere',
    //   'mane_event_fireFeet.begin',
    //   'mane_event_fireFeet.cycle',
    //   'mane_event_fireFeet.end',
    //   'mane_event_fireFloor.begin',
    //   'mane_event_fireFloor.cycle',
    //   'mane_event_fireFloor.end',
    //   'mane_event_lightningBeg',
    //   'mane_event_shockwave'
    // ]
  },
  skill_buckle_up: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/skills/buckleup/',
    json: 'vfx_part_skill_buckleup.json',
    atlas: 'vfx_part_skill_buckleup.atlas'
    // skins: [
    //   'default'
    // ],
    // clips: [
    //   '.buckle_up_dmg',
    //   '.buckle_up_heal',
    //   'buckle_up.begin',
    //   'buckle_up.cycle',
    //   'buckle_up.end',
    //   'buckle_up_dmg',
    //   'buckle_up_heal'
    // ]
  },
  skill_alpha_ram: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/skills/alpha_ram/',
    json: 'Droppod.json',
    atlas: 'Droppod.atlas'
    // skins: [
    //   'default'
    // ],
    // clips: [
    //   'charging',
    //   'drop',
    //   'idle',
    //   'open',
    //   'spawn_bark',
    //   'spawn_target'
    // ]
  },
  skill_static_sprint: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/skills/static_sprint/',
    json: 'vfx_part_skill_staticsprint.json',
    atlas: 'vfx_part_skill_staticsprint.atlas'
    // skins: [
    //   'default'
    // ],
    // clips: [
    //   'heal_area',
    //   'heal_effect',
    //   'sparks_body',
    //   'sparks_ground'
    // ]
  },
  skill_baah_blitz: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/skills/baahblitz/',
    json: 'vfx_part_skill_baahblitz.json',
    atlas: 'vfx_part_skill_baahblitz.atlas'
    // skins: [
    //   'default'
    // ],
    // clips: [

    //   '.view_fullview',

    //   'beam_thin',

    //   '.view_debuff',
    //   'debuff_aura',
    //   'debuff_particles',

    //   '.view_target',
    //   'target_begin',
    //   'target_cycle',
    //   'target_end'
    // ]
  },
  heal_orb: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/repair_kit',
    json: 'repair-kit.json',
    atlas: 'repair-kit.atlas'
    // skins: [
    //   'default'
    // ],
    // clips: [
    //   'activating',
    //   'activation_finishes',
    //   'idle'
    // ]
  },
  capture_point: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/capture_point',
    json: 'capture_point.json',
    atlas: 'capture_point.atlas'
    // skins: [
    //   'default'
    // ],
    // clips: [
    //   'activate_ally',
    //   'activate_enemy',
    //   'neutral'
    // ]
  },
  /** Terraforming seed-burst pad. */
  tfSeedBurstPad: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/terraforming/v2/seed-burst-pad',
    json: 'seed_burst_pad.json',
    atlas: 'seed_burst_pad.atlas'
    // clips: [
    //   'activate_ally',
    //   'charged',
    //   'charging',
    //   'neutral_charge'
    // ]
  },
  dm_gate: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/gate',
    json: 'gate.json',
    atlas: 'gate.atlas'
    // skins: [
    //   'default'
    // ],
    // clips: [
    //   'close',
    //   'open'
    // ]
  },
  vfx_tower_shield: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/vfx/vfx_tower_shield',
    json: 'vfx_tower_shield.json',
    atlas: 'vfx_tower_shield.atlas'
    // skins: [
    //   'default'
    // ],
    // clips: [
    //   'ally_shield',
    //   'enemy_shield',
    //   'neutral_shield'
    // ]
  }
} as const;
